import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const ChatbotIframe = ({ open, onClose }) => {
  const chatbotUrl = "https://apollochatbot.beko.com/"; // Replace with your chatbot link

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      PaperProps={{
        style: { height: '80vh', overflow: 'hidden' }
      }}
    >
      <DialogTitle>
        <Typography variant="h6">Chatbot</Typography>
        <IconButton
          aria-label="close"
          onClick={onClose}
          style={{ position: 'absolute', right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent style={{ padding: 0 }}>
        <iframe
          src={chatbotUrl}
          title="Chatbot"
          width="100%"
          height="100%"
          style={{ border: 'none' }}
        />
      </DialogContent>
    </Dialog>
  );
};

export default ChatbotIframe;
